module.exports = __webpack_public_path__ + "assets/pdf/E16-en-flash-droughts.3ccfed78.pdf";